import React from 'react';
import { Table, Button, Space, Typography, Tag } from 'antd';
import { EyeOutlined, DeleteOutlined, DownloadOutlined, SettingOutlined, MailOutlined } from '@ant-design/icons';

const { Text } = Typography;

const Dfm2026Tab = ({ 
  applications, 
  loading, 
  canDelete,
  onRefresh, 
  onView, 
  onDelete,
  onDownloadVideo,
  onDownloadCV,
  onNotificationClick,
  onEmailTemplatesClick,
  formatDate 
}) => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      responsive: ['sm']
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => <Text strong>{`${text} ${record.surname}`}</Text>,
      ellipsis: true,
      responsive: ['xs']
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      width: 80,
      responsive: ['md']
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      responsive: ['lg'],
      ellipsis: true
    },
    {
      title: 'Contact',
      dataIndex: 'contactNumber',
      key: 'contactNumber',
      responsive: ['md'],
      width: 130
    },
    {
      title: 'CV Type',
      dataIndex: 'cvPath',
      key: 'cvType',
      width: 100,
      responsive: ['lg'],
      render: (cvPath) => (
        cvPath ? <Tag color="blue">File</Tag> : <Tag color="green">Text</Tag>
      )
    },
    {
      title: 'Submitted',
      dataIndex: 'submittedAt',
      key: 'submittedAt',
      render: (date) => formatDate(date),
      responsive: ['md'],
      width: 120
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space direction="vertical" size="small">
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => onView(record)}
            size="small"
            block
          >
            View
          </Button>
          <Button
            icon={<DownloadOutlined />}
            onClick={() => onDownloadVideo(record.id)}
            size="small"
            block
          >
            Video
          </Button>
          {record.cvPath && (
            <Button
              icon={<DownloadOutlined />}
              onClick={() => onDownloadCV(record.id)}
              size="small"
              block
            >
              CV
            </Button>
          )}
          {canDelete && (
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record.id)}
              size="small"
              block
            >
              Delete
            </Button>
          )}
        </Space>
      ),
      width: 120,
      fixed: 'right'
    },
  ];

  return (
    <>
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Space>
          <Button 
            onClick={onRefresh}
            loading={loading}
          >
            Refresh
          </Button>
          <Text type="secondary">
            Total Applications: {applications.length}
          </Text>
        </Space>
        <Space>
          {onEmailTemplatesClick && (
            <Button
              icon={<MailOutlined />}
              onClick={onEmailTemplatesClick}
            >
              Email Templates
            </Button>
          )}
          <Button
            icon={<SettingOutlined />}
            onClick={onNotificationClick}
          >
            Notification Settings
          </Button>
        </Space>
      </div>
      
      <Table
        columns={columns}
        dataSource={applications}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) => 
            `${range[0]}-${range[1]} of ${total} applications`,
        }}
        scroll={{ x: true }}
      />
    </>
  );
};

export default Dfm2026Tab;
